
export const esTipoTope = (idTipoRegla: number) => idTipoRegla === 3;

export const redirectToReglaTab = (idRegla: number, tab: string) => `/regla/${idRegla}/${tab}`;

export const isProductiveRule = (props:any)=> (props.record?.estado === 1 || props?.estado === 1);

